/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Button, Divider, Stack , Tab, Tabs, 
} from '@mui/material';

import React, { useState } from 'react';
import color from './Colors';
import ReviewList from './ReviewList';

function ReviewTabs({
  googleData,newData,selectedTab,setSelectedTab, 
}) {    
  const handleChange = (event,newValue) => {
    setSelectedTab(newValue);
  };
  return (
    <div>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        sx={{
          px: { xs: 1, sm: 3 },
          borderBottom: '1px solid #f1f5f9',
          '& .MuiTabs-indicator': { height: '3px', borderRadius: '3px 3px 0 0' },
        }}
      >
        <Tab
          sx={{
            fontSize: '13px', fontWeight: 400, textTransform: 'none', fontFamily: 'inherit', minHeight: '52px', '&.Mui-selected': { fontWeight: 500 },
          }}
          label="Reviews"
        />
        <Tab
          sx={{
            fontSize: '13px', fontWeight: 400, textTransform: 'none', fontFamily: 'inherit', minHeight: '52px', '&.Mui-selected': { fontWeight: 500 },
          }}
          label="Google Reviews"
        />
      </Tabs>

      {selectedTab === 0 && (
      <div>
          {newData?.map((review) => (
            <ReviewList
              key={review.review_id}
              name={review.reviewer_name}
              comment={review.review}
              createTime={review.review_created_at}
              replied={review.response_flag}
              reply={review.response}
              star={review.rating_stars}
              source={review.source}
              sourceLogo={review.source_logo_url}
              reviewURL={review.review_url}
              responsePlatform={review.response_platform}
              responseCreated={review.response_created_at}
            />
          ))}
      </div>
      )}

      {selectedTab === 1 && (
      <div>        
        {googleData?.entity?.map((review) => (
          <ReviewList
            key={review.review_id}
            name={review.reviewer_name}
            comment={review.review}
            createTime={review.review_created_at}
            replied={review.response_flag}
            reply={review.response}
            star={review.rating_stars}
            source={review.source}
            sourceLogo={review.source_logo_url}
            reviewURL={review.review_url}
          />
        ))}
        <div className="flex justify-center px-5 pt-2">
          <div className="flex w-full cursor-pointer items-center justify-center rounded-xl bg-[#1976d2] px-5 py-3 text-sm font-medium text-white shadow-sm transition duration-200 hover:-translate-y-0.5 hover:bg-[#1565c0] hover:shadow-md sm:w-auto">
            <a href={googleData?.link} target="__blank">View all Google reviews</a>
          </div>
        </div>
      </div>
      )}
    
    </div>
    
  );
}

export default ReviewTabs;
